{
  "loading": "Indlæser ...",
  "placeholder": "Vælg en mulighed ..."
}